export const Color = {
    brandGreen: "#7ff800",
    turbo: "#fce403",
    white: "#ffffff",
    black: "#000000",
    lightBlack: "#232323",
    darkBlack: "#171717",
    grey: "#717171",
    pink: "#ff014f",
    orange: "#ff8a00",
    red: "#ff014f",
    darkGrey: "#161616",
    slateGrey: "#1e1e1e",
    softGrey: "#303030",
    blackGrey: "#0a0a0a",
    darkGreen:"#001b01",
    blackGreen:"#001000",
    middleGrey: "#484848",
    smokeGrey: "#cacaca",
    limeGreen:"#d2f800",
    silverGrey: "#5c5c5c",


    vipYellow:"#f9c600",
    vipPurple: "#aa9aca",
    vipBlue:"#74adb3",

    yellow: "#ffff00",
    pear: "#d5ec37",
    inchWorm: "#7aec37",

    transparent: "transparent",

    scCards: "#12011A",
    roulBJ:"#071A01",
    vidPoker:"#000E24",
};